exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nameTooltip-6be13{margin-left:5px}.managerContainer-d0fc0{display:flex;align-items:center}", ""]);

// Exports
exports.locals = {
	"nameTooltip": "nameTooltip-6be13",
	"managerContainer": "managerContainer-d0fc0"
};